const ThumbsUpIcon = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.667 13.333H3.333V4.667L8 0l.833.833a.875.875 0 0 1 .192.317c.05.133.075.261.075.383v.234l-.733 2.9h4.3c.355 0 .666.133.933.4.267.266.4.577.4.933v1.333c0 .078-.011.161-.033.25a8.05 8.05 0 0 1-.067.25l-2 4.7c-.1.223-.267.411-.5.567a1.302 1.302 0 0 1-.733.233Zm-6-1.333h6l2-4.667V6h-6l.9-3.667-2.9 2.9V12ZM3.333 4.667V6h-2v6h2v1.333H0V4.667h3.333Z"
    />
  </svg>
)
export default ThumbsUpIcon
